import styled from "styled-components";
import Button from "../Components/Button";
import { ReactComponent as SessionHourglass } from "../Images/session_hourglass.svg";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { useGoToAddr } from "../Utils/navigationUtils";

const SessionExpired = () => {
  const goToAddr = useGoToAddr();
  return (
    <div className="page-wrapper center" style={{ height: "1080px" }}>
      <SessionBox>
        <div className="hrz-wrapper center" style={{ marginTop: "70px" }}>
          <SessionHourglass />
        </div>
        <div className="hrz-wrapper center" style={{ marginTop: "40px" }}>
          <p className="infoTitle">자동 로그아웃</p>
          <p className="infoTitle" style={{ color: "#000000" }}>
            &nbsp;안내
          </p>
        </div>
        <div className="hrz-wrapper center" style={{ marginTop: "20px" }}>
          <p style={{ color: "#222222" }}>
            사용자의 안전한 사이트이용을 위해 로그인 후 약 30분간 사이트
          </p>
        </div>

        <div className="hrz-wrapper center">
          <p>이용이 발생하지 않아</p>
          <p style={{ color: "#1167ed", fontFamily: "notoSans-medium" }}>
            &nbsp;자동 로그아웃&nbsp;
          </p>
          <p>되었습니다.</p>
        </div>

        <div className="hrz-wrapper center" style={{ marginTop: "10px" }}>
          <p style={{ color: "#222222" }}>
            개인정보보호를 위해 다시 로그인 해 주세요.
          </p>
        </div>

        <div
          className="hrz-wrapper center"
          style={{ marginTop: "60px" }}
          onClick={() => goToAddr("login")}
        >
          <Button
            message="로그인 하러가기"
            addr="login"
            style={{ marginTop: "60px" }}
          />
        </div>
      </SessionBox>
    </div>
  );
};

const SessionBox = styled.div`
  width: 860px;
  height: 526px;
  border-radius: 20px;
  background-color: #ffffff;
  .infoTitle {
    font-family: "notoSans-bold";
    font-size: 24px;
    color: #1167ed;
  }
`;
export default SessionExpired;
